import { Theme, css } from '@emotion/react';

export const CVVHostedField = ({ colors, spacing }: Theme) => css`
  background-clip: padding-box;
  background-color: white;
  border: 1px solid ${colors.borderDefault};
  display: block;
  font-size: 1.6rem;
  height: 48px;
  line-height: 1.5;
  margin-top: ${spacing(1)}px;
  max-width: 8rem;
  padding: 0 0.75rem;
`;

export const threeUpFields = ({ breakpoints, spacing }: Theme) => css`
  display: flex;
  flex-direction: column;

  & > * + * {
    flex: 1 0 33%;
    margin-top: ${spacing(3)}px;
  }

  ${breakpoints.up('sm')} {
    align-items: flex-start;
    flex-direction: row;
    & > * + * {
      // flex: property from outer scope (default) still applies here
      margin-left: ${spacing(1)}px;
      margin-top: 0;
    }
  }
`;

export const mobileOnlyDivider = ({ breakpoints }: Theme) => css`
  ${breakpoints.up('sm')} {
    display: none;
  }
`;

export const billingAddressContainer = ({ breakpoints, spacing }: Theme) => css`
  ${breakpoints.up('sm')} {
    margin-top: ${spacing(2.5)}px;
  }
`;

export const cvvRevalidationArea = ({ hidden }: { hidden: boolean }) =>
  hidden &&
  css`
    display: none;
  `;
